import { KANBAN_PARENT_TYPE } from "../../components/kanban/kanban.constants";
import { apiCall } from "./service";
import {
  BASE_URL,
  URL_UPDATE_TASK,
  URL_DELETE_TASK,
  URL_GET_TASK_DETAILS,
  URL_TASKS,
  URL_CREATE_TASK,
} from "./URL";


const URL_KANBAN_TASKS = `${BASE_URL}tasks`;

const kanbanService = {
  getKanbanTasks(params) {
    const { parent, parentId, pageNumber, pageSize, status, searchTerm } = params;
    const queryParams = new URLSearchParams({
      pageNumber: pageNumber.toString(),
      pageSize: pageSize.toString(),
    });

    switch (parent) {
      case KANBAN_PARENT_TYPE.PROJECT:
        queryParams.append("projectId", parentId)
        break;
        
      case KANBAN_PARENT_TYPE.SCOPE:
        queryParams.append("scopeId", parentId)
        break;
      default:
        break;
    }

    if (searchTerm) 
        queryParams.append("searchTerm", searchTerm);

    if (status !== undefined && status !== null)
      queryParams.append("status", status);

    return apiCall.get({
      url: `${URL_KANBAN_TASKS}/kanban?${queryParams.toString()}`,
    });
  },

  updateTaskStatus(params) {
    return apiCall.put({
      url: `${URL_UPDATE_TASK}${params.id}/Status`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  getTaskDetails(params) {
    return apiCall.get({
      url: `${URL_GET_TASK_DETAILS}${params.id}`,
      isAuthToken: true,
    });
  },

  duplicateTask(params) {
    return apiCall.post({
      url: `${URL_TASKS}/${params.id}/duplicate`,
      params: params.payload || {},
    });
  },
  
  deleteTask(params) {
    return apiCall.delete({
      url: `${URL_DELETE_TASK}${params.id}`,
      isAuthToken: true,
    });
  },


};


export default kanbanService;
